// @ts-nocheck
import useScrollContext from "@store/Framework/Common/Hooks/useScrollContext";
import { useEffect, useState } from "react";

export default () => {
    const [scrollInit, setScrollInit] = useState(false);
    const { setScroll } = useScrollContext();

    const handleScroll = () => {
        setScroll(document.body.scrollTop || document.documentElement.scrollTop);
    };

    useEffect(() => {
        if (scrollInit) {
            handleScroll();
        }
    }, [scrollInit]);

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        setScrollInit(true);

        window.addEventListener("scroll", handleScroll);
    }, []);
};
